import { Skeleton } from '@mui/material'

function NotificationItemSkeleton() {
    return (
        <div className={`notification-item ni-skeleton`}>
            <Skeleton className='skeleton-img' variant="rectange" />
        </div>
    );
}

export default NotificationItemSkeleton;